import { useDispatch } from 'react-redux';
import { useTranslation } from 'next-i18next';
import { customizationSwitchStep } from '@/utils/customizationUtils';
import { changeBoxCustomization } from '@/redux/slices/customization.slice';
import { Dropdown } from '@/components/common/design-system/Dropdown.ds';
import MillesimaPrice from '@/components/common/price/MillesimaPrice';
import { IconedLink } from '@/components/common/iconedLinks';
import { showConfirmModal } from '@/redux/slices/gui.slice';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from './CartCustomization.module.scss';
import { CUSTOMIZATION_NAMES, CUSTOMIZATION_RETURN_URL } from '@/constants/customization';
import { URLS } from '@/constants/urls';

export const CartCustomization = ({ cartProduct, readOnly }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { id, customization, customizationQt, quantity, customizationPrice } = cartProduct;

  const options = Array(quantity + 1).fill(1).map((_, i) => ({
    value: i.toString(),
    label: i.toString()
  }));

  const onEdit = () => {
    customizationSwitchStep(id, CUSTOMIZATION_NAMES.REVIEW, {
      returnUrl: CUSTOMIZATION_RETURN_URL.CHECKOUT,
    });
  };

  const onDelete = () => {
    dispatch(showConfirmModal({
      content: {
        title: t('winebox.removeCustomization'),
        content: t('winebox.removeCustomizationContent'),
        cancel: t('btn.cancel'),
        confirm: t('btn.delete'),
        confirmClick: () => dispatch(changeBoxCustomization({
          boxId: id,
          customization: {},
          customizationQt: 0,
          isGetCart: true
        }))
      }
    }));
  };

  const handleChangeQuantity = (qty) => {
    if (qty.value === 0) {
      onDelete();
    } else {
      dispatch(changeBoxCustomization({
        boxId: id,
        customization: customization,
        customizationQt: qty.value,
        isGetCart: true
      }));
    }
  };

  return (
    <>
      <img src={URLS.WB_CART_IMG} alt="winebox" />
      <div className={styles['customization-content']}>
        <div className={styles['product-name']}>{t('mini-cart.engraving')}</div>
        <p className={styles['paragraph']}>{`${t('customization:review.sumLabel.text')} : ${customization.message}`}</p>
        <p className={styles['paragraph']}>{`${t('customization:review.sumLabel.orientation')} : ${t(`customization:orientation.${customization.orientation?.toLowerCase()}`)}`}</p>
        <p className={styles['paragraph']}>{`${t('customization:review.sumLabel.size')} : ${t(`customization:size.${customization.size?.toLowerCase()}`)}`}</p>
        {customization.signature?.content && (
          <p className={styles['paragraph']}>{`${t('customization:review.sumLabel.signature')} : ${customization.signature.content}`}</p>
        )}
        {!readOnly && (
          <div className="edit-delete">
            <span className="edit">
              <IconedLink
                icon={URLS.EDIT_BLACK}
                alt="modify"
                height={10}
                width={10}
                text={'btn.modify'}
                onClicked={onEdit}
              />
            </span>
            <span className="delete">
              <IconedLink
                icon={URLS.ORION_CLOSE_BLACK}
                alt="delete"
                height={10}
                width={10}
                text={'btn.delete'}
                onClicked={onDelete}
              />
            </span>
          </div>
        )}
      </div>
      <div className={styles['dropdown-and-price-container']}>
        {readOnly ? (
          <div>{`x ${quantity}`}</div>
        ) : (
          <Dropdown
            defaultValue={customizationQt}
            options={options}
            onChange={handleChangeQuantity}
          />
        )}
        <div className={styles['price-infos']}>
          <MillesimaPrice
            value={customizationPrice} className={{ container: styles.price }}
          />
        </div>
      </div>
    </>
  );
};

export default CartCustomization;
